import JobsService from '../../services/JobsService';
import UploadsService from '../../services/UploadsService';
import { JOB_STATUS } from '../../util/jobStatus';

export const namespaced = true;

export const state = {
  job: null,
  jobs: [],
};

export const mutations = {
  SET_JOB(state, job) {
    state.job = job;
  },
  ADD_JOB(state, job) {
    if (!state.jobs) {
      state.jobs = [];
    }
    state.jobs.push(job);
  },
  SET_JOBS(state, jobs) {
    state.jobs = jobs;
  },
};

export const actions = {
  createJob({ commit }, {
    file,
    name,
    inputLanguage,
    desiredLanguage,
    additionalKeywords,
  }) {
    const additionalKeywordsArray = additionalKeywords.split(',')
      .map(value => value.trim())
      .filter(value => value.length > 0 && value !== ' ');
    return UploadsService.uploadFile(file)
      .then(({ data }) => JobsService.createJob({
        name: name.trim(),
        uploadId: data.id,
        inputLanguage,
        desiredLanguage,
        extraKeywords: additionalKeywordsArray,
      }))
      .then(({ data }) => {
        commit('ADD_JOB', data);
        return data;
      });
  },
  getJobs({ commit }) {
    return JobsService.getJobs()
      .then(({ data }) => {
        commit('SET_JOBS', data);
      });
  },
};

export const getters = {
  newestJobsFirst(state) {
    return state.jobs.sort((c1, c2) => {
      const c1CreatedAt = new Date(c1.createdAt);
      const c2CreatedAt = new Date(c2.createdAt);
      return c2CreatedAt.getTime() - c1CreatedAt.getTime();
    });
  },
  filterJobs: (state, getters) => ({
    jobName,
    status,
    fromDate,
    toDate,
  }) => {
    let filteredJobs = getters.newestJobsFirst;
    if (jobName && jobName.length > 0 && jobName !== ' ') {
      filteredJobs = filteredJobs
        .filter(job => job.name.toLowerCase()
          .includes(jobName.toLowerCase()));
    }
    if (status && status.toLowerCase() === 'processing') {
      filteredJobs = filteredJobs
        .filter(job => job.status === JOB_STATUS.AWAITING_PROCESSING
          || job.status === JOB_STATUS.PROCESSING);
    } else if (status && status.toLowerCase() === 'completed') {
      filteredJobs = filteredJobs.filter(job => job.statis === JOB_STATUS.COMPLETED);
    }
    if (fromDate) {
      const fromTime = new Date(fromDate).getTime();
      filteredJobs = filteredJobs
        .filter(job => new Date(job.createdAt).getTime() >= fromTime);
    }
    if (toDate) {
      const toTime = new Date(toDate).setHours(23, 59, 59, 999);
      filteredJobs = filteredJobs
        .filter(job => new Date(job.createdAt).getTime() <= toTime);
    }
    return filteredJobs;
  },
};
